<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 29.333c7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334zm-1.48-9.201c-.147.143-.269.262-.535.262l.05-.76v-.008l.136-2.027 5.084-4.588c.159-.141.067-.23-.106-.206a.532.532 0 00-.06.012l-.018.006a.71.71 0 00-.16.073l-6.275 3.958-2.71-.846c-.586-.179-.59-.581.131-.87l10.561-4.072c.482-.22.948.115.764.854l-1.799 8.475c-.125.602-.49.746-.993.468l-2.74-2.024-1.317 1.28-.013.013z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandTelegramFilled'
}
</script>
